import {
    Box,
    ControlList,
    RightSidebar,
    useListFilterState,
    useTranslations,
} from "@harea/component";
import { DEMAND_DAYOFF_LIST_ID } from "../container/ProjectDayOffViewsDemandContainer";
import { useDayOffControlFilterForm } from "../hooks/useDayOffControlFilterForm";

const DayOffListFilter = (props: DayOffListFilterProps) => {
    const controlFilter = useDayOffControlFilterForm();
    const [FILTER] = useTranslations(i18n);

    const { filter, setFilter } = useListFilterState(DEMAND_DAYOFF_LIST_ID);

    const handleFilterChange = (value: Record<string, any>) => {
        setFilter((v: any) => {
            const hasValidValues = Object.values(value).some(val => 
                val !== undefined && 
                val !== null && 
                val !== '' && 
                (!Array.isArray(val) || val.length > 0)
            );
            
            if (!hasValidValues) {
                return v;
            }
            
            return {
                ...v,
                data: {
                    ...v.data,
                    ...resetFilter(),
                    ...cleanFilter(),
                    ...value,
                    ...handleFilterByUsers(value?.employee, filter),
                    ...handleFilterBetweenDateRange(value?.dateRange),
                    ...handleFilterByStatus(value.status),
                },
            };
        });
    };

    return (
      <RightSidebar
        className={`right-sidebar-absolute box box-white ${props.open ? "" : "hide"}`}
        onClose={props?.onClose}
      >
        <Box
          title={FILTER}
          icon="fa-solid fa-filter"
          className="h-full p-0 shadow-none"
                style={{ paddingTop: '15px'}}
        >
          <ControlList
            {...controlFilter}
            value={{
              ...filter.data,
                        employee: filter.data?.employee?.id_among?.map((item) => ({id: item}))
            }}
                    onChange={handleFilterChange} />
        </Box>
      </RightSidebar>
    );
};

const i18n = [
    "std_filter",
]

export default DayOffListFilter;

type DayOffListFilterProps = {
    open: boolean;
    onClose: () => void;
};

const resetFilter = () => {
    return {
        user: undefined,
        dateBegin_supOrEquals: undefined,
        dateBegin_infOrEquals: undefined,
        invitations: undefined,
        dateEnd_inf: undefined,
        dateEnd_infOrEquals: undefined,
        dateEnd_supOrEquals: undefined,
    };
};

const cleanFilter = () => {
    return {
        users: undefined,
        dateRange: undefined,
        status: undefined,
        department: undefined,
    };
};

const handleFilterByUsers = (users?: Array<{ id: number }>, filter?: any) => {
    if (users?.length > 0) {
        return {
            employee: {
                department: filter?.data?.employee?.department,
                id_among: users?.map((u) => u.id),
            },
        };
    }

    return {};
};

const handleFilterBetweenDateRange = (dateRange?: Array<string>) => {
    if (dateRange?.length > 0 && dateRange.every((d) => d)) {
        return {
            // Chevauchement avec la plage sélectionnée (gère les congés longs).
            dateBegin_infOrEquals: dateRange[1],
            dateEnd_supOrEquals: dateRange[0],
        };
    }

    return {};
};

const handleFilterByStatus = (status?: string) => {

    return { status: status };
};
